import { Customer } from "./Customer";

export interface CustomerDocuments {
    status: "PENDING" | "VALIDATING" | "COMPLETED" | "REFUSED";
    documents: CustomerDocument[];
    customer: Customer;
}

export interface CustomerDocument {
    id: string;
    name: string;
    description: string;
    value?: string;
}

export interface CustomerDocumentsRequest {
    documents: CustomerDocumentRequest[];
}

export interface CustomerDocumentRequest {
    id: string;
    url: string;

    name: string;
    description: string;
}

export const CustomerDocumentStatus = ["PENDING", "VALIDATING", "COMPLETED", "REFUSED"];